// extracted by mini-css-extract-plugin
export default {"banner":"AssigneePicker-module__banner--is9sU"};